import { render, staticRenderFns } from "./edition_mobile.vue?vue&type=template&id=205ade88&scoped=true&"
import script from "./edition_mobile.vue?vue&type=script&lang=js&"
export * from "./edition_mobile.vue?vue&type=script&lang=js&"
import style0 from "./edition_mobile.vue?vue&type=style&index=0&id=205ade88&scoped=true&lang=scss&"
import style1 from "./edition_mobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ade88",
  null
  
)

export default component.exports